"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _get = _interopRequireDefault(require("lodash/get"));

var _react = _interopRequireWildcard(require("react"));

var _context = require("../context");

var _Checkbox = _interopRequireDefault(require("../../../components/Checkbox"));

var _Avatar = _interopRequireDefault(require("../../../components/Avatar"));

var _Badge = _interopRequireDefault(require("../../../components/Badge"));

var _utils = require("../utils");

var _styles = require("./styles");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var sizeMapping = {
  small: 'small',
  medium: undefined
}; // This is used below to silence a React warning about
// having a controlled input without a change handler.

var noop = process.env.NODE_ENV === 'production' ? undefined : function () {};

function isDecoration(decoration) {
  var type = (0, _get.default)(decoration, 'type');
  return type !== undefined;
}

function DecorationComponent(props) {
  var disabled = props.disabled,
      rest = _objectWithoutProperties(props, ["disabled"]);

  switch (props.type) {
    case 'Avatar':
      return _react.default.createElement(_Avatar.default, rest);

    case 'Badge':
      return _react.default.createElement(_Badge.default, _extends({}, rest, {
        variant: "square",
        color: disabled ? 'licoriceMousse' : props.color
      }));

    case 'Icon':
      {
        var Icon = props.icon;
        return _react.default.createElement(Icon, null);
      }

    default:
      return null;
  }
} // We always render the checkbox/radio inputs so that regular form
// submission (i.e. one not handled programmatically) still works.


function Option(props) {
  var id = props.id,
      label = props.label,
      decoration = props.decoration,
      disabled = props.disabled,
      borderRadius = props.borderRadius,
      labelDetails = props.labelDetails,
      _props$showCheckbox = props.showCheckbox,
      showCheckbox = _props$showCheckbox === void 0 ? true : _props$showCheckbox,
      _props$size = props.size,
      size = _props$size === void 0 ? 'small' : _props$size;
  var decorationType = (0, _get.default)(decoration, 'type');

  var _useOptionsList = (0, _context.useOptionsList)(),
      toggleItemSelection = _useOptionsList.toggleItemSelection,
      selectedIds = _useOptionsList.selectedIds,
      name = _useOptionsList.name,
      multiple = _useOptionsList.multiple,
      renderOptionLabel = _useOptionsList.renderOptionLabel,
      activeId = _useOptionsList.activeId,
      setInputMethod = _useOptionsList.setInputMethod,
      updateActiveId = _useOptionsList.updateActiveId,
      inputMethod = _useOptionsList.inputMethod,
      selectable = _useOptionsList.selectable,
      itemRole = _useOptionsList.itemRole;

  var checked = selectedIds.includes(id);
  var commonProps = {
    name: name,
    checked: checked,
    onChange: noop,
    tabIndex: -1
  };
  var handleMouseEnter = (0, _react.useCallback)(function () {
    setInputMethod('mouse');
    updateActiveId(disabled ? '' : id);
  }, [setInputMethod, updateActiveId, disabled, id]);
  var handleClick = (0, _react.useCallback)(function () {
    if (!disabled) toggleItemSelection(id);
  }, [toggleItemSelection, id, disabled]);
  var LabelWrapper = (0, _react.useMemo)(function () {
    return function (_ref) {
      var children = _ref.children;
      return selectable ? _react.default.createElement("label", {
        className: "label"
      }, children) : _react.default.createElement("div", {
        className: "label"
      }, children);
    };
  }, [selectable]);
  return _react.default.createElement(_styles.Container, {
    "aria-disabled": !!disabled,
    "aria-selected": checked,
    borderRadius: borderRadius,
    "data-id": id,
    key: id,
    onClick: handleClick,
    multiple: !!multiple,
    isActive: activeId === id,
    tabIndex: -1,
    onMouseEnter: handleMouseEnter,
    inputMethod: inputMethod,
    role: itemRole,
    size: size
  }, (0, _utils.isLink)(props) ? _react.default.createElement(_styles.StyledLink, {
    tabIndex: -1,
    to: props.linkTo,
    text: label,
    icon: isDecoration(decoration) && decoration.type === 'Icon' ? decoration.icon : undefined,
    disabled: !!disabled
  }) : _react.default.createElement(LabelWrapper, null, selectable && (multiple && !!showCheckbox ? _react.default.createElement(_Checkbox.default, _extends({}, commonProps, {
    disabled: !!disabled,
    size: sizeMapping[size],
    value: props.value
  })) : _react.default.createElement("input", _extends({}, commonProps, {
    type: "radio",
    hidden: true,
    value: props.value
  }))), isDecoration(decoration) && _react.default.createElement(_styles.DecorationComponentContainer, {
    disabled: !!disabled && decorationType !== 'Icon'
  }, _react.default.createElement(DecorationComponent, decoration)), renderOptionLabel ? renderOptionLabel({
    id: id,
    label: label,
    labelDetails: labelDetails,
    value: props.value,
    disabled: disabled,
    meta: props.meta
  }) : _react.default.createElement(_styles.StyleLabelWrapper, null, _react.default.createElement(_styles.StyledLabel, null, label), labelDetails && _react.default.createElement(_styles.StyledLabelDetails, {
    id: "optionLabelDetails",
    size: sizeMapping[size]
  }, labelDetails))));
}

var _default = _react.default.memo(Option);

exports.default = _default;